/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { BlogCardProps } from "@components/elements/ref-sections";
import { ResearchCardFragment } from "@cosmos/hygraph-schema";

export const getResearchCardFragment = (item: ResearchCardFragment, publicationLabel: string): BlogCardProps => {
	return {
		badges: [{ label: publicationLabel || "Publication" }],
		date: item.publicationDate,
		title: {
			text: item.title?.text || "",
			html: item.title?.html || item.title?.text || "",
		},
		desc: item.desc || "",
		href: item.href || "",
		asset: {
			id: "",
			url: item.asset?.url || "",
			optUrl: item.asset?.optUrl || "",
			width: 660,
			altText: "",
		},
		footer: item.footer || undefined,
		buttons: [],
	};
};
